import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { ButtonBase } from '@mui/material';

// project imports
import config from 'config';
import LogoHeader from 'ui-component/LogoHeader';
import { MENU_OPEN } from 'store/actions';
import LogoHeaderMinimal from 'ui-component/LogoHeaderMinimal';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = ({ isMinimal = false }) => {
  const defaultId = useSelector((state) => state.customization.defaultId);
  const dispatch = useDispatch();
  return (
    <ButtonBase disableRipple onClick={() => dispatch({ type: MENU_OPEN, id: defaultId })} component={Link} to={config.defaultPath}>
      {isMinimal ? <LogoHeaderMinimal /> : <LogoHeader />}
    </ButtonBase>
  );
};

export default LogoSection;
